module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user-credential-page"
  }, [_c('div', {
    ref: "printContent",
    staticClass: "credential-card"
  }, [_c('h1', {
    staticClass: "credential-title"
  }, [_vm._v("Hellokid 課程購買憑據")]), _vm._v(" "), _c('div', {
    staticClass: "section"
  }, [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v("課程方案資料")]), _vm._v(" "), _c('div', {
    staticClass: "info-row"
  }, [_c('div', {
    staticClass: "info-item"
  }, [_c('span', {
    staticClass: "info-label"
  }, [_vm._v("訂單編號：")]), _vm._v(" "), _c('span', {
    staticClass: "info-value"
  }, [_vm._v(_vm._s(_vm.orderNum))])]), _vm._v(" "), _c('div', {
    staticClass: "info-item"
  }, [_c('span', {
    staticClass: "info-label"
  }, [_vm._v("購買日期：")]), _vm._v(" "), _c('span', {
    staticClass: "info-value"
  }, [_vm._v(_vm._s(_vm.orderDate))])])]), _vm._v(" "), _c('div', {
    staticClass: "info-row"
  }, [_c('div', {
    staticClass: "info-item"
  }, [_c('span', {
    staticClass: "info-label"
  }, [_vm._v("學員ID：")]), _vm._v(" "), _c('span', {
    staticClass: "info-value"
  }, [_vm._v(_vm._s(_vm.userId))])]), _vm._v(" "), _c('div', {
    staticClass: "info-item"
  }, [_c('span', {
    staticClass: "info-label"
  }, [_vm._v("學員姓名：")]), _vm._v(" "), _c('span', {
    staticClass: "info-value"
  }, [_vm._v(_vm._s(_vm.nickName))])])])]), _vm._v(" "), _c('table', {
    staticClass: "detail-table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("基礎方案")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.basePlanDetail))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.amount) + " " + _vm._s(_vm.currencyLabel))])]), _vm._v(" "), (_vm.hasActivity) ? _c('tr', [_c('td', [_vm._v("活動明細")]), _vm._v(" "), _c('td', [_c('ul', {
    staticClass: "activity-list"
  }, [(_vm.discountNum > 0) ? _c('li', [_vm._v("• " + _vm._s(_vm.discountNum) + "節一對一外教課")]) : _vm._e(), _vm._v(" "), (_vm.discount > 0) ? _c('li', [_vm._v("• 現金優惠" + _vm._s(_vm.discount) + _vm._s(_vm.currencyLabel))]) : _vm._e()])]), _vm._v(" "), _c('td', [_vm._v("—")])]) : _vm._e(), _vm._v(" "), _c('tr', {
    staticClass: "total-row"
  }, [_c('td', [_vm._v("合計")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.totalLessons))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.payAmount) + " " + _vm._s(_vm.currencyLabel))])])])]), _vm._v(" "), _c('div', {
    staticClass: "section"
  }, [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v("確認資料")]), _vm._v(" "), _c('div', {
    staticClass: "info-row"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "info-item signer-item"
  }, [_c('span', {
    staticClass: "info-label"
  }, [_vm._v("簽單人：")]), _vm._v(" "), _c('div', {
    staticClass: "signer-name-block"
  }, [_c('span', {
    staticClass: "info-value"
  }, [_vm._v(_vm._s(_vm.createUser))]), _vm._v(" "), _c('img', {
    staticClass: "company-seal",
    attrs: {
      "src": "/static/bangder-seal.jpg",
      "alt": "公章"
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "credential-toolbar not-print"
  }, [_c('div', {
    staticClass: "toolbar_inbox"
  }, [_c('button', {
    staticClass: "toolbtn",
    on: {
      "click": _vm.printWeb
    }
  }, [_vm._v("打印本憑據")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "col-project"
  }, [_vm._v("項目")]), _vm._v(" "), _c('th', {
    staticClass: "col-detail"
  }, [_vm._v("詳情")]), _vm._v(" "), _c('th', {
    staticClass: "col-total"
  }, [_vm._v("合計總金額")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-item"
  }, [_c('span', {
    staticClass: "info-label"
  }, [_vm._v("開票單位：")]), _vm._v(" "), _c('span', {
    staticClass: "info-value"
  }, [_vm._v("香港邦德爾科技有限公司")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-db761d34","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/order/UserCredential.vue
// module id = 1970
// module chunks = 8